































































































































import cloneDeep from 'lodash/cloneDeep';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'

import uniq from 'lodash/uniq';

@Component({
  computed: {
    ...mapState('ubic', [
      'token', 'actor'
    ]),
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter',

      'documents', 'lastMeta'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'exportData', 'exportAsXLSX'
    ])
  },
  components: {
    TitleBar
  }
})
export default class Catalog extends Vue {
  // radioButton = 1;
  // open = false

  opened: any[] = [];

  get titleStack () {
    return [
      ['Главная страница', 'catalog'],
      'История заказов'
    ]
  }

  onDetailToggle(row: any, to: string) {
    if (to == 'open') {
      this.opened = uniq([
        ...this.opened,
        row.id
      ]);
    } else {
      this.opened = uniq(
        this.opened.filter(($row) => $row.id != row.id)
      );
    }
  }

  getQueryParam(field: string) {
    return this.$route.query ? cloneDeep(this.$route.query[field]) : null
  }

  // ---------------------------------------------------------------------------

  onPage($event: any) {
    if (this.$route.query.page != $event) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          // @ts-ignore
          page: $event,
        }
      })  
    }
  }

  // ---------------------------------------------------------------------------

  get defaultSort() {
    return [this.$route.query.sortField || 'name', this.$route.query.sortDirection || 'asc']
  }
  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  public beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

}
